import React, { useContext } from 'react';
import classNames from 'classnames';

import LocationSearch from 'components/shared/LocationSearch/LocationSearch';

import { CustomerContext } from 'context/customer';

import styles from './LocationSearchModal.module.scss';

export default function LocationSearchModal({ initialAddress }: { initialAddress: string }) {
  const { user } = useContext(CustomerContext);
  const savedAddresses = user?.delivery?.addresses || [];

  return (
    <div
      className={classNames(styles.locationSearchModal, {
        [styles.tall]: savedAddresses.length,
      })}
    >
      <div>
        <h2 className={styles.header}>Enter Your Location</h2>
        <div className={styles.locationSearchWrapper}>
          <LocationSearch
            initialAddress={initialAddress}
            mparticleSource="search_listing"
            cssModifierGoogleInput={styles.googleInputModifier}
            cssModifierGoogleIcon={styles.googleIconModifier}
            cssModifierDefaultDropdown={styles.defaultDropdownModifier}
            updateArrowButtonState={() => {
              undefined;
            }}
          />
        </div>
      </div>
    </div>
  );
}
